import { render, staticRenderFns } from "./DetallePago.vue?vue&type=template&id=f5e245aa&scoped=true&"
import script from "./DetallePago.vue?vue&type=script&lang=js&"
export * from "./DetallePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e245aa",
  null
  
)

export default component.exports